import { render, staticRenderFns } from "./TextListWithTitle.vue?vue&type=template&id=9c5a09d8&"
import script from "./TextListWithTitle.vue?vue&type=script&lang=js&"
export * from "./TextListWithTitle.vue?vue&type=script&lang=js&"
import style0 from "./TextListWithTitle.vue?vue&type=style&index=0&id=9c5a09d8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports